import Register from "./components/Register";
import getBackendEndpoint from "./config"
import { Route, Switch } from "react-router-dom";
import Login from "./components/Login";
import Products from "./components/Products";
import Checkout from "./components/Checkout";
import Thanks from "./components/Thanks";

export const config = {
  endpoint : getBackendEndpoint()  
};

function App() {
  return (
    <div className="App">
          <Switch>
            <Route exact path="/">
              <Products/>
            </Route>
            <Route exact path="/products">
              <Products/>
            </Route>

            <Route path="/register">
              <Register/>
            </Route>

            <Route path="/login">
              <Login/>
            </Route>
            <Route path="/checkout">
              <Checkout/>
            </Route>
            <Route path="/thanks">
              <Thanks/>
            </Route>
          </Switch>
    </div>
  );
}

export default App;
